module.exports = __webpack_public_path__ + "img/logo-site-mayenne.387571b6.png";